import React from 'react';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import ToggleButtonGroup, { ToggleButtonGroupProps } from 'components/ToggleButtonGroup';

export interface AppToolbarToggleButtonGroupProps extends React.ComponentPropsWithRef<'div'> {
  /** The contents for the each button. Consider using `ToggleGroupButton`component. */
  children: React.ReactNode;
  /* ToggleButtonGroup properties. See `ToggleButtonGroup` component for details.  */
  toggleButtonGroupProps?: Partial<ToggleButtonGroupProps>;
}

/** Formatted ToggleButtonGroup for use on the AppToolbar.  */
const AppToolbarToggleButtonGroup = (props: AppToolbarToggleButtonGroupProps) => {
  const {
    toggleButtonGroupProps,
    children,
  } = props;
  const { elevationProps: userElevation, ...restOfToggleButtonGroupProps } = toggleButtonGroupProps;
  const { style: userElevationStyle, ...restOfUserElevation } = userElevation || {};
  const ELEVATION_PROPS = {
    elevationProps: {
      style: {
        height: '2rem',
        margin: `0 ${Tokens.SPACING.SPACING_8}`,
        ...userElevationStyle,
      },
      ...restOfUserElevation,
    }
  };
  return (
    <ToggleButtonGroup {...ELEVATION_PROPS} {...restOfToggleButtonGroupProps} >
      {children}
    </ToggleButtonGroup>
  );
};

AppToolbarToggleButtonGroup.defaultProps = {
  toggleButtonGroupProps: {},
};
AppToolbarToggleButtonGroup.displayName = 'AppToolbarToggleButtonGroup';
export default AppToolbarToggleButtonGroup;
